import React, { useState } from 'react';
import { Container, ThisCard, ThisCardAnal } from './styles';
import { Materialize } from "~/styles/materializeGrid";
import { Label, TextArea, Select, Input} from "~/componentes/CustomForm";
import Acoordion from '~/componentes/Acoordion';



import IconClientesAtivo from '~/assets/icones/IconClientesAtivo.svg';
import IconCardAtivo from '~/assets/icones/IconCardAtivo.svg';
import IconMarkComp from '~/assets/icones/IconMarkComp.svg';
import Logo from '~/assets/logos/Logo Locomotiva.svg';


function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  let analista = [{ id: 1, nome: 'Jorge Medeiros', aberto: true },{ id: 1, nome: 'Jorge Medeiros', aberto: true },{ id: 1, nome: 'Jorge Medeiros', aberto: true }];
  let acesso = [{ id: 1, nome: 'Jorge Medeiros', aberto: true }];

  return (
    <Container>
      {data?.map((thisData, i) => (
        <ThisCard
          className={
            linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'
          }
          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
          key={thisData?.id || i}
          id={thisData?.id || i}
          index={i}
          ativo={linhaAtiva === thisData?.id ? true : false}
        >
          <div className="card-list">
            {analista?.map(thisAnal => (
              <ThisCardAnal
                className={
                  linhaAtiva === thisAnal?.id ? 'card-item ativo' : 'card-item'
                }
                {...{ data: thisAnal, linhaAtiva, setLinhaAtiva }}
                key={thisAnal?.id || i}
                id={thisAnal?.id || i}
                index={i}
                ativo={linhaAtiva === thisAnal?.id ? true : false}
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="card-text">
                      <p className="descricao">#{thisData?.codigo}</p>
                      <p className="titulo">{thisData?.nome}</p>
                      <p className="descricao-cord"></p>
                    </div>
                  </div>
                  <div className="card-ativo">
                    <img src={IconCardAtivo} alt="Vazio" />
                  </div>
                  <div className="card">
                      <img src={IconClientesAtivo} alt="Vazio" />
                  </div>
                </div>
                <div className="card-bottom">
                  {thisData?.produtos?.map((thisProduto, o) => (
                    <div className="card-grupo">
                      <p className="grupoperfil">{thisProduto?.produto?.titulo}</p>
                    </div>
                  ))}
                </div>
              </ThisCardAnal>
            ))}
          </div>
          <div className="card-info">
            <div className="card-top">
              <div className="card-top-left">
                <img src={IconMarkComp} alt="Vazio" />
                <div className="texts">
                  <p className="titulo">Locomotiva</p>
                  <p className="sub-titulo">responsavel@locomotiva.com.br</p>
                </div>
              </div>
              <div className="card-top-right">
                <p className="cod">#0001</p>
              </div>
            </div>
            <Materialize className="padding-form">
              <div className="row">
                <Label title="Descrição *" className="col s5 m5 l5">
                 <TextArea name="descricao" defaultValue="Descrição" />
                </Label>
                <Label title="Logo" className="col s4 m4 l4">
                  <div className="point">
                    <div className="logo">
                      <img className="logo_img" src={Logo} alt="Vazio" />
                    </div>
                  </div>
                </Label> 
                <div className="col s3 m3 l3">
                  <Acoordion title="Módulos Utilizados*" name="a" itens={analista} /> 
                </div>
              </div>
              <div className="card-bottom">
                <div className="card-grupo">
                  <p className="grupoperfil">Acessos</p>
                </div>
              </div>
              <div className="row">
                <Label title="Usa VPN *" className="col s2 m2 l2">
                  <Select isString
                    list={{ list: [{ id: "S", titulo: "Sim" }, { id: "N", titulo: "Não" }], value: "id", label: "titulo" }}
                    name="final"
                  />
                </Label>
                <Label title="Responsável VPN *" className="col s3 m3 l3">
                  <Input name="titulo" defaultValue="Responsável" />
                </Label>
                <Label title="Responsável ERP - Protheus *" className="col s4 m4 l4">
                  <Select isString
                    list={{ list: [{ id: "S", titulo: "Responsável da ERP - Protheus" }, { id: "N", titulo: "Não" }], value: "id", label: "titulo" }}
                    name="final"
                  />
                </Label>
              </div>
              <div className="row">
                <Label title="Base Teste *" className="col s2 m2 l2">
                  <Select isString
                    list={{ list: [{ id: "S", titulo: "Sim" }, { id: "N", titulo: "Não" }], value: "id", label: "titulo" }}
                    name="final"
                  />
                </Label>
                <Label title="Link Para Download VPN *" className="col s7 m7 l7">
                  <Input name="titulo" defaultValue="Responsável" />
                </Label>
              </div>
              <div className="row">
                <Label title="Configurações do SmartClient *" className="col s9 m9 l9">
                 <TextArea name="configuracoes" />
                </Label>
              </div>
              <div className="row">
                <Label title="Instruções" className="col s9 m9 l9">
                 <TextArea name="instrucoes" />
                </Label>

                {/* <div className="col s5 m5 l5">
                  {despesas.length > 0 && (
                    <Acoordion
                      defaultSelect={mountedData?.despesas}
                      title={'Despesas '}
                      name={'despesas'}
                      itens={despesas}
                    />
                  )}
                </div> */}
                
              </div>
            </Materialize>
          </div>
        </ThisCard>
      ))}
    </Container>
  );
}

export default CustomBodyContent;
